import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-history",
  "use": "icon-history-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-history\"><path d=\"M12.588 11.917a1.833 1.833 0 0 1-3.244-1.704L7.187 6.477a.957.957 0 0 1 1.656-.957l2.106 3.647H11c.679 0 1.271.368 1.588.916h4.829a.917.917 0 0 1 0 1.834h-4.829zM11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm0-1.833a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.334z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol